<template>
  <kst-container class="kst-warehouse-details">
    <kst-form :loading="isLoading" :title="title">
      <template #top-right>
        <Action :data="data"/>
      </template>

      <Details :data="data"/>
    </kst-form>
  </kst-container>
</template>

<script>
import AxiosMixin from "@/mixins/AxiosMixin.js";
import RouterMixin from "@/mixins/RouterMixin.js";
import Info from "../WarehouseInfo.js";
import Services from "../WarehouseServices.js";

import Action from "./WarehouseDetails_Action";
import Details from "./WarehouseDetails_Details";

export default {
  mixins: [AxiosMixin, RouterMixin],
  components: {
    Action,
    Details
  },
  data: () => ({
    data: {},
    isLoading: false,
     // error
    formWarnings: null,
    failureInit: null
  }),
  computed: {
    title() {
      return this.$route.meta.title;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const id = this.getUrlParam(this.$kst.Enum.Param.ID);
      this.formWarnings = null;

      if (!id) {
        this.formWarnings = [Info.Message.Details_ParamIncomplete];
        return;
      }

      this.initLoad(id);
    },

    initLoad(id) {
      this.isLoading = true;
      this.failureInit = null;

      this.loadDetails(id);
    },
    initLoad_End() {
      this.isLoading = false;
    },

    loadDetails(id) {
      const config = Services.getWarehouseDetails(id);
      this.runAxios(config, null, this.loadDetails_Success, this.loadDetails_Error);
    },
    loadDetails_Success(data) {
      this.data = data;
      this.initLoad_End();
    },
    loadDetails_Error(message) {
      this.failureInit = message;
      this.initLoad_End();
    }
  }
}
</script>